<template>
    <router-view></router-view>
</template>

<script>
  export default {
    name: 'PublicLayout',
  };
</script>


// WEBPACK FOOTER //
// src/Public.vue